import { render, staticRenderFns } from "./mentionsTables.vue?vue&type=template&id=6fc513f8&"
import script from "./mentionsTables.vue?vue&type=script&lang=js&"
export * from "./mentionsTables.vue?vue&type=script&lang=js&"
import style0 from "./mentionsTables.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports